import { redirect, ROUTE_NAMES } from '$router/config'
import {
  deleteApp,
  deleteGroup,
  deletePermission,
  deleteRole
} from '$services/api'
import { useRequest } from 'ahooks'
import { toast } from 'sonner'

export const useDeleteService = () => {
  const { runAsync: deleteAppAsync, loading: deletingApp } = useRequest(
    deleteApp,
    {
      manual: true,
      onSuccess: () => {
        toast.success('App has been deleted!')
        redirect(ROUTE_NAMES.APPS, options => options)
      }
    }
  )

  const { runAsync: deleteGroupAsync, loading: deletingGroup } = useRequest(
    deleteGroup,
    {
      manual: true,
      onSuccess: () => {
        toast.success('Group has been deleted!')
        redirect(ROUTE_NAMES.APP_GROUPS, options => options)
      }
    }
  )

  const { runAsync: deleteRoleAsync, loading: deletingRole } = useRequest(
    deleteRole,
    {
      manual: true,
      onSuccess: () => {
        toast.success('Role has been deleted!')
        redirect(ROUTE_NAMES.APP_ROLES, options => options)
      }
    }
  )

  const { runAsync: deletePermissionAsync, loading: deletingPermission } =
    useRequest(deletePermission, {
      manual: true,
      onSuccess: () => {
        toast.success('Permission has been deleted!')
        redirect(ROUTE_NAMES.APP_PERMISSIONS, options => options)
      }
    })

  return {
    deleteAppAsync,
    deletingApp,

    deleteGroupAsync,
    deletingGroup,

    deleteRoleAsync,
    deletingRole,

    deletePermissionAsync,
    deletingPermission
  }
}
